import type { Audience } from './types';

export function getMemberCount(audience: Audience): number {
	return audience.member_count ?? 0;
}

export function getInitials(name: string): string {
	const parts = name.trim().split(/\s+/);
	const first = parts[0]?.[0] ?? '';
	const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';
	return (first + last).toUpperCase() || '?';
}

export function formatSource(source: string): string {
	return source.charAt(0).toUpperCase() + source.slice(1);
}

export function formatDate(iso: string): string {
	const date = new Date(iso);
	if (Number.isNaN(date.getTime())) return '';
	return date.toLocaleDateString(undefined, {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
	});
}
